import { render, staticRenderFns } from "./AiAssistDrawer.vue?vue&type=template&id=521c2726&scoped=true"
import script from "./AiAssistDrawer.vue?vue&type=script&lang=js"
export * from "./AiAssistDrawer.vue?vue&type=script&lang=js"
import style0 from "./AiAssistDrawer.vue?vue&type=style&index=0&id=521c2726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c2726",
  null
  
)

export default component.exports